import Vue from 'vue';
import _ from 'lodash';

export default Vue.component('global-table', {
  template: require('./template.html'),
  computed: {
    itemList() {
      const list = this.items;
      const sortColIndex = _.findIndex(this.cols, c => c === this.defaultSort);
      const sortOn = this.sortKey || this.cols[sortColIndex];
      const searchInput = this.filterKey.replace(/\s/g, '');
      const emptySearch = searchInput === '';
      const searchCols = this.cols.concat(this.addedSearchKeys);
      const filtered = _.filter(list, (item) => {
        const matched = [];
        _.forEach(searchCols, (col) => {
          const value = _.toLower(this.cleanItem(item[col], col));
          if (value.includes(_.toLower(this.filterKey))) {
            matched.push(value);
          }
        });
        return (!emptySearch && matched.length > 0) || emptySearch;
      });
      return _.chain(filtered).sort((a, b) => {
        // We'll sort accending by default and we'll also ignore case
        // since that may confuse non-technical users
        const ascDesc = this.sortMap[sortOn];
        a = _.isString(a[sortOn]) ? _.toLower(a[sortOn]) : a[sortOn]; // eslint-disable-line
        b = _.isString(b[sortOn]) ? _.toLower(b[sortOn]) : b[sortOn]; // eslint-disable-line
        return (a === b ? 0 : a < b ? -1 : 1) * ascDesc; // eslint-disable-line
      }).value();
    },
  },
  data() {
    return {
      paginate: ['itemList'],
      filterKey: '',
      sortKey: '',
      sortMap: {},
    };
  },
  name: 'global-table',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    cols: {
      type: Array,
      required: true,
      default: () => ['created'],
    },
    addedSearchKeys: {
      type: Array,
      required: false,
      default: () => [],
    },
    itemLabel: {
      type: String,
      required: false,
      default: 'Item',
    },
    defaultSort: {
      type: String,
      required: false,
      default: 'created',
    },
    searchPlaceholder: {
      type: String,
      required: false,
      default: 'Search...',
    },
    display: {
      type: Number,
      required: false,
      default: 8,
    },
    thin: {
      type: Boolean,
      required: false,
      default: false,
    },
    colors: {
      type: [Boolean, Function],
      required: false,
      default: false,
    },
    timeZone: {
      type: [Boolean, String],
      required: false,
      default: false,
    },
  },
  created() {
    this.sortMap = _.zipObject(this.cols, _.fill(Array(this.cols.length), -1));
  },
  methods: {
    onItemClick(item) {
      this.$emit('on-item-click', item);
    },
    onSearch(e) {
      this._debounce(() => {
        this.filterKey = e.target.value;
      }, 250);
    },
    cleanItem(item, col) {
      let i = item || '--';
      if (col === 'totalBought') {
        i = _.isNumber(i) ? i.toString() : '0';
      }
      if (col === 'status' && i !== '--') {
        i = this._startCase(i);
      }
      if (['created', 'date'].includes(col) && i !== '--') {
        i = this._zoneFormat({
          date: i,
          format: 'MM-DD-YYYY hh:mm A z',
          zone: this.timeZone,
        });
      }
      return i;
    },
    setSortKey(k) {
      this.sortKey = k;
      // Invert the value for ascDesc
      this.sortMap[k] = this.sortMap[k] * -1;
    },
    seperateCamalCase(str, mobile) {
      const tail = mobile ? ': ' : '';
      return str.replace(/([A-Z])/g, g => ` ${g[0].toLowerCase()}`) + tail;
    },
    highlight(ctx, query, col, it) {
      const c = this.cleanItem(ctx, col, it);
      return c.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
    colorConditions(params) {
      let rules = {};
      if (this.colors) {
        rules = this.colors(params);
      }
      return rules;
    },
  },
});



// WEBPACK FOOTER //
// ./src/mixins/components/table/index.js